import React from 'react';
import { FaPepperHot, FaDollarSign } from 'react-icons/fa';

export type TagState = 'include' | 'exclude';

interface TagToggleButtonProps {
  label: string;
  state: TagState;
  onClick: () => void;
}

const TagToggleButton: React.FC<TagToggleButtonProps> = ({
  label,
  state,
  onClick,
}) => {
  const base =
    'text-sm rounded-md px-2 py-1 whitespace-nowrap transition inline-flex items-center';
  const styles: Record<TagState, string> = {
    include: 'bg-tagGreenBG text-tagGreenText border border-tagGreenText',
    exclude: 'bg-red-100   text-red-800   border border-red-600',
  };
  const suffix = state === 'include' ? '✔︎' : '✖︎';

  const norm = label
    .trim()
    .toLowerCase()
    .replace(/[-_\s]/g, '');

  if (norm === 'none') {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${base} ${styles[state]}`}
      >
        Not spicy
        <span className="ml-1">{suffix}</span>
      </button>
    );
  }

  const spiceMap: Record<string, number> = { mild: 1, medium: 2, hot: 3 };
  if (spiceMap[norm] != null) {
    const lvl = spiceMap[norm];
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${base} ${styles[state]}`}
      >
        <span className="flex items-center gap-0.5">
          {[1, 2, 3].map((i) => (
            <FaPepperHot
              key={i}
              className={i <= lvl ? 'opacity-100' : 'opacity-30'}
            />
          ))}
        </span>
        <span className="ml-1">{suffix}</span>
      </button>
    );
  }

  const costMap: Record<string, number> = {
    cheap: 1,
    midrange: 2,
    expensive: 3,
  };
  if (costMap[norm] != null) {
    const lvl = costMap[norm];
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${base} ${styles[state]}`}
      >
        <span className="flex items-center gap-0.5">
          {[1, 2, 3].map((i) => (
            <FaDollarSign
              key={i}
              className={i <= lvl ? 'opacity-100' : 'opacity-30'}
            />
          ))}
        </span>
        <span className="ml-1">{suffix}</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${base} ${styles[state]}`}
    >
      <span className="truncate">{label}</span>
      <span className="ml-1">{suffix}</span>
    </button>
  );
};

export default TagToggleButton;
